import React, { useState } from 'react';
import './CurriculumStyle.css';
import Skill from '../components/Skill'
import "./SkillStyle.css";

const Curriculum = () => {

  const [educationDetails, setEducationDetails] = useState({
    UniversidadMilitar: false,
    FaculdadeUnelaya: false,
    MaharishiUniversity: false,
  });

  const [experienceDetails, setExperienceDetails] = useState({
    LoadTech: false,
    MilleniumBPO: false,
    InternshipUSP: false,
  });

  const toggleEducationDetails = (item) => {
    setEducationDetails((prevState) => ({
      ...prevState,
      [item]: !prevState[item],
    }));
  };

  const toggleExperienceDetails = (item) => {
    setExperienceDetails((prevState) => ({
      ...prevState,
      [item]: !prevState[item],
    }));
  };

  const renderButtonContent = (isExpanded) => {
    return isExpanded ? (
      <span className="button-content">-</span>
    ) : (
      <span className="button-content">+</span>
    );
  };

  const programmingLanguages = [
    { name: 'Java', level: 85 },
    { name: 'JavaScript (Js)', level: 70 },
    { name: 'Python', level: 60 },
    { name: 'HTML5', level: 80 },
    { name: 'C++', level: 70 },
     { name: 'PHP', level: 60 },
    
  ];
  
  const frameworksAndLibraries = [
    { name: 'Spring Boot (Java framework)', level: 80 },
    { name: 'React (JavaScript library)', level: 80 },
    { name: 'Zk (Java framework)', level: 85 },
    { name: 'Angular', level: 60 },
    { name: 'CSS', level: 85 },
  ];
  const CloudInfrantucture = [
    { name: 'AWS', level: 80 },
    { name: 'Zabbix', level: 75 },
   
  ];
  const databasesAndDataStorage = [
    { name: 'MongoDB', level: 70 },
    { name: 'SQL', level: 80 },
    { name: 'H2 (in-memory database)', level: 80 },
  ];
  return (
    <div className="cv">
      <div className="cv-margin">
        <div className="cv-section">
          <h2>Education</h2>
          <ul>
            <li>
              <span className="cv-date">2015 - 2020</span>
              <div className="cv-content">
                <h3>Bachelor's Degree in Mechatronics Engineering</h3>
                <p>Universidad Militar Nueva Granada</p>
                {educationDetails.UniversidadMilitar && (
                  <div>
 
                      <ul>
                          <li> University Experiences:
                            <ul>
                              <li/>
                              <li>Meritorious Thesis (4.5 / 5)</li>
                              <li>Robotics</li>
                              <li>Control</li>
                              <li>Programming</li>
                              <li>Mechanics</li>
                              <li>Monitor in LabView</li>
                              <li>Representation as an intern at the Universidad de Sao Paulo</li>
                            </ul>
                          </li>
                        </ul>
                              
                            
                  </div>
                )}
                <button
                  className={`toggle-button ${educationDetails.UniversidadMilitar ? 'expanded' : ''}`}
                  onClick={() => toggleEducationDetails('UniversidadMilitar')}
                >
                  {renderButtonContent(educationDetails.UniversidadMilitar)}
                </button>
              </div>
            </li>
            <li>
              <span className="cv-date">2020 - 2021</span>
              <div className="cv-content">
                <h3>Specialization in Full Stack web development - Brazil</h3>
                <p>Faculdade Unelaya</p>
                {educationDetails.FaculdadeUnelaya && (
                  <div>
                    
                    <ul>
                          <li> University Experiences:
                            <ul>
                              <li/>
                              <li>Development of API's web and web service</li>
                              <li>Back end development</li>
                              <li>Configuration and change management - DevOps</li>
                              <li>Infrastructure for web development</li>
                              <li>Front end development</li>
                            </ul>
                          </li>
                        </ul>
                    
                  </div>
                )}
                <button
                  className={`toggle-button ${educationDetails.FaculdadeUnelaya ? 'expanded' : ''}`}
                  onClick={() => toggleEducationDetails('FaculdadeUnelaya')}
                >
                  {renderButtonContent(educationDetails.FaculdadeUnelaya)}
                </button>
              </div>
            </li>
            <li>
              <span className="cv-date">2022 - Present</span>
              <div className="cv-content">
                <h3>M.Sc in Computer Science</h3>
                <p>Maharishi International University</p>
                {educationDetails.MaharishiUniversity && (
                  <div>
                     <ul>
                          <li> University Experiences:
                            <ul>
                              <li/>
                              <li>Fundament Programming in java "OOP and Data Structure"</li>
                              <li>Modern Progamming practices "Uml Desgin and  Streams pipe line java 8"</li>
                              <li>Cloud Computing "Amazon web Services"</li>
                              <li>Relational Data Base "Design data Base, sql DML, DDL, NoSql ,MongoDB"</li>
                              <li>Work permission In usa as Cpt </li>
                            </ul>
                          </li>
                        </ul>
                  </div>
                )}
                <button
                  className={`toggle-button ${educationDetails.MaharishiUniversity ? 'expanded' : ''}`}
                  onClick={() => toggleEducationDetails('MaharishiUniversity')}
                >
                  {renderButtonContent(educationDetails.MaharishiUniversity)}
                </button>
              </div>
            </li>
          </ul>
        </div>

        <div className="cv-section">
          <h2>Experience</h2>
          <ul>
            <li>
              <span className="cv-date">2021 - 2022</span>
              <div className="cv-content">
                <h3>Java Software Developer</h3>
                <p>LoadTech US</p>
                {experienceDetails.LoadTech && (
                  <div>
                                   <ul>
                          <li>Achievements:
                            <ul>
                              <li></li>
                              <li>Made a tool that permits the user to find routes for trucks and informs exact details of its routes, including the costs in gasoline, tolls, etc.</li>
                              <li>Creation of a dashboard that permits the user to monitor his loads</li>
                              <li>Correction of bugs</li>
                              <li>Complements throughout the platform</li>
                              <li>Connection to Zabbix (Network manager) in order to monitor the platform and anticipate any future failure</li>
                            </ul>
                          </li>
                          <li> Software:
                            <ul>
                              <li></li>
                              <li>Use of REST API</li>
                              <li>Labor organization in Spring methodology</li>
                              <li>ZK framework, H2 database, and PostgreSQL</li>
                            </ul>
                          </li>
                        </ul>
                  </div>
                )}
                <button
                  className={`toggle-button ${experienceDetails.LoadTech ? 'expanded' : ''}`}
                  onClick={() => toggleExperienceDetails('LoadTech')}
                >
                  {renderButtonContent(experienceDetails.LoadTech)}
                </button>
              </div>
            </li>
            <li>
              <span className="cv-date">2020 - 2021</span>
              <div className="cv-content">
                <h3>Bilingual IT help desk analyst</h3>
                <p>Millenium BPO-Transunion</p>
                {experienceDetails.MilleniumBPO && (
                  <div>
                   <ul>
                          <li> Task:
                            <ul>
                              <li/>
                              <li>"SolidWorks" mechanical design</li>
                              <li>Electronic connection in the aircraft</li>
                              <li>Control engineering applied in aeronautics</li>
                              <li>Programmable design in Matlab and Arduino to control an aircraft</li>
                              <li>Nationals Instruments DAQ acquisition card control</li>
                            </ul>
                          </li>
                        </ul>
                  </div>
                )}
                <button
                  className={`toggle-button ${experienceDetails.MilleniumBPO ? 'expanded' : ''}`}
                  onClick={() => toggleExperienceDetails('MilleniumBPO')}
                >
                  {renderButtonContent(experienceDetails.MilleniumBPO)}
                </button>
              </div>
            </li>
            <li>
              <span className="cv-date">2020 - 2020</span>
              <div className="cv-content">
                <h3>Aeronautical Research Assistant</h3>
                <p>Internship at the Universidad de Sao Paulo</p>
                {experienceDetails.InternshipUSP && (
                  <div>
                   <ul>
                          <li> Task:
                            <ul>
                              <li/>
                              <li>Handling of mechanical tools:</li>
                              <li>"SolidWorks" mechanical design</li>
                              <li>Electronic connection in the aircraft</li>
                              <li>Control engineering applied in aeronautics</li>
                              <li>Programmable design in Matlab and Arduino to control an aircraft</li>
                              <li>Nationals Instruments DAQ acquisition card control</li>
                            </ul>
                          </li>
                        </ul>
                  </div>
                )}
                <button
                  className={`toggle-button ${experienceDetails.InternshipUSP ? 'expanded' : ''}`}
                  onClick={() => toggleExperienceDetails('InternshipUSP')}
                >
                  {renderButtonContent(experienceDetails.InternshipUSP)}
                </button>
              </div>
            </li>
          </ul>
        </div>

        <div className="cv-section">
  <h2>Skills</h2>

  <div className="firstC">
    <div className="cv-languages">
      <h3>Programming Languages</h3>
      {programmingLanguages.map((skill, index) => (
        <Skill key={index} name={skill.name} level={skill.level} />
      ))}
    </div>
    <div className="cv-frame">
      <h3>Frameworks and Libraries</h3>
      {frameworksAndLibraries.map((skill, index) => (
        <Skill key={index} name={skill.name} level={skill.level} />
      ))}
    </div>
  </div>

      <div className='firstC'>
      <div className="cv-DB">
        <h3>Databases and Data Storage </h3>
      {databasesAndDataStorage.map((skill, index) => (
        <Skill key={index} name={skill.name} level={skill.level} />
      ))}
      </div>
      <div className="cv-cloud">

            <h3>Cloud Infrastructure and Monitoring </h3>
      {CloudInfrantucture.map((skill, index) => (
        <Skill key={index} name={skill.name} level={skill.level} />
      ))}
      </div>
     
      </div>
          
        </div>
      </div>
    </div>
  );
};

export default Curriculum;
